const headerStyle = () => {
    return { borderColor: '#a81933' };
};

const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

export const columns = [
    {    
        dataField: 'name',
        text: 'Name',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {    
        dataField: 'franchiseDownloadType',
        text: 'Download Type',
        sort: true,
        headerStyle: headerStyle,
        style: {...columnStyle, width: '100%'}
    },
    {    
        dataField: 'description',
        text: 'Description',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    }
];
    
export const sorting = [{
    dataField: 'Name',
    order: 'asc'
}];